import { render, staticRenderFns } from "./AddPrivilege.vue?vue&type=template&id=698b5438&scoped=true"
import script from "./AddPrivilege.vue?vue&type=script&lang=js"
export * from "./AddPrivilege.vue?vue&type=script&lang=js"
import style0 from "./AddPrivilege.vue?vue&type=style&index=0&id=698b5438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b5438",
  null
  
)

export default component.exports